import React, { useContext } from "react";
import { Link } from "react-router-dom";
import PsContext from "../../context";

const StepMenu = (props) => {
  const context = useContext(PsContext);

  const currentStep = () => {
    if (props.activeKey == "step1") return 1;
    if (props.activeKey == "step2") return 2;
    if (props.activeKey == "step3") return 3;
    if (props.activeKey == "step4") return 4;
    return 1;
  };

  const steps = [
    { id: 1, key: "step1", label: "Step-I" },
    { id: 2, key: "step2", label: "Step-II" },
    { id: 3, key: "step3", label: "Step-III" },
    { id: 4, key: "step4", label: "Step-IV" },
  ];

  const getStatus = (id) => {
    if (currentStep() === id) return "active";
    if (currentStep() > id) return "completed";
    return "pending";
  };

  const progressWidth = ((currentStep() - 1) / (steps.length - 1)) * 100;

  const isEdit = (step) => {
    if (step.id === 1)
      return (
        context.user.application_declaration == "0" &&
        context.user.registration_completed == "1"
      );
    if (step.id === 2)
      return (
        context.user.application_declaration == "0" &&
        context.user.marks_uploaded == "1"
      );
    if (step.id === 3)
      return (
        context.user.application_declaration == "0" &&
        context.user.certificates_uploaded == "1"
      );
    return false;
  };

  return (
    <div className="body-stepper-wrapper">
      <div className="body-stepper-container">
        <div
          className="body-step-line-active"
          style={{ width: `${progressWidth}%` }}
        ></div>

        {steps.map((step) => {
          const status = getStatus(step.id);
          return (
            <div key={step.id} className={`body-step-item ${status}`}>
              <div className="body-step-number shadow-sm">
                {status === "completed" ? (
                  <i className="fa-solid fa-check fs-12"></i>
                ) : (
                  step.id
                )}
              </div>
              <div className="body-step-label">
                {isEdit(step) && (
                  <Link
                    to={
                      step.id == 1
                        ? "/edit/personal"
                        : step.id == 2
                        ? "/edit/marks"
                        : "/edit/certificates"
                    }
                    className="me-1 text-primary"
                  >
                    <i className="fa-solid fa-pen-to-square"></i>
                  </Link>
                )}
                {step.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepMenu;
